import React from 'react';
import { Space } from 'antd';
import IndividualCompetenceTable from '../individualCompetenceTable/individualCompetenceTable';
import IndividualCompetenceTableSummary from '../individualCompetenceTable/individualCompetenceTableSummary';
import ByCompetenceBarChartIndividual from '../../graphics/byCompetenceBarChartIndividual';
import ScoreByDimensionByRelationships from '../scoreByDimensionByRelationships/scoreByDimensionByRelationships';

const LeadershipByDimensionsIndividual = ({
    chartGroups,
    globalAverage,
    orgGlobalAverage,
    dimension,
    redLight,
    yellowLight,
    color,
    type,
    indexPage,
}) => {
    const hasFewSubdimensions = dimension.subdimensions.length <= 10;

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {hasFewSubdimensions && indexPage === 0 && (
                <>
                    <IndividualCompetenceTableSummary
                        competence={dimension}
                        redLight={redLight}
                        yellowLight={yellowLight}
                    />
                    <IndividualCompetenceTable
                        competence={dimension}
                        redLight={redLight}
                        yellowLight={yellowLight}
                    />
                </>
            )}


            {!hasFewSubdimensions && indexPage === 0 && (
                <IndividualCompetenceTableSummary
                competence={dimension}
                redLight={redLight}
                yellowLight={yellowLight}
                />
            )}

            {!hasFewSubdimensions && indexPage === 1 && (
                <IndividualCompetenceTable
                competence={dimension}
                redLight={redLight}
                yellowLight={yellowLight}
                />
            )}

            {(hasFewSubdimensions && indexPage === 1 || !hasFewSubdimensions && indexPage === 2) && (
                <>
                    <ByCompetenceBarChartIndividual
                        data={chartGroups}
                        redLight={redLight}
                        yellowLight={yellowLight}
                    />
                    <ScoreByDimensionByRelationships
                        dimension={dimension}
                        redLight={redLight}
                        yellowLight={yellowLight}
                    />
                </>
            )}
        </Space>
    );
};

export default LeadershipByDimensionsIndividual;
